import { Map } from 'immutable';
import { combineReducers } from 'redux';
import {
  FETCH_ARTICLE_PAGE_VIEW,
  FETCH_ARTICLE_PAGE_VIEW_SUCCESS,
  FETCH_ARTICLE_PAGE_VIEW_FAIL
} from '../actions/actionTypes';

const data = (state = Map(), { type, payload, meta }) => {
  switch (type) {
    case FETCH_ARTICLE_PAGE_VIEW_SUCCESS:
      return state.merge({ [meta.urlPath]: payload });

    default:
      return state;
  }
};

const request = (state = Map(), { type, meta, error }) => {
  switch (type) {
    case FETCH_ARTICLE_PAGE_VIEW: {
      const next = { [meta.urlPath]: { status: 'LOADING' } };
      return state.merge(next);
    }

    case FETCH_ARTICLE_PAGE_VIEW_SUCCESS: {
      const next = { [meta.urlPath]: { status: 'SUCCESS', statusCode: 200 } };
      return state.merge(next);
    }

    case FETCH_ARTICLE_PAGE_VIEW_FAIL: {
      const next = { [meta.urlPath]: { status: 'ERROR', statusCode: error.response.status } };
      return state.merge(next);
    }

    default:
      return state;
  }
};

export default combineReducers({
  data,
  request
});



// WEBPACK FOOTER //
// ./src/reducers/page.js